import React, { useEffect, useState } from "react";
import moment from "moment";
import RecommendationScrollableTabHeader from "./RecommendationScrollableTabHeader";

function RecommendationSideSubTab({ customer }) {
const [activeTab, setActiveTab] = useState();
  useEffect(() => {
    const sortedData = sortData(customer.reorderResponses);
    const keys = Object.keys(sortedData);
    if (keys.length > 0 && !activeTab) {
      setActiveTab(keys[0]);
    }
  }, []);

 
  
  function sortData(reorderResponses) {
    if(reorderResponses){
    const data = reorderResponses
      .sort((responseA, responseB) => {
        return new Date(responseB.updatedAt) - new Date(responseA.updatedAt);
      })
      .reduce((acc, response) => {
        const id = response._id;
        acc[id] = acc[id] || [];
        acc[id].push({
          displayDate: moment(response.updatedAt).format(
            "MMM Do YYYY, h:mm a"
          ),
          ...response,
        });

        return acc;
      }, {});
    const sortedData = Object.values(data)?.reduce((acc, entry) => {
      const date = entry[0].displayDate;
      acc[date] = entry;
      return acc;
    }, {});
    return sortedData;
  }
  return [];
  }


  return (

    <div className="side-sub-ab scrollable-container  shadow rounded">
      <RecommendationScrollableTabHeader
        dates={Object.keys(sortData(customer?.reorderResponses))}
        setActiveTab={setActiveTab}
        case_id={customer.id}
      />
      {Object.entries(sortData(customer?.reorderResponses))?.map(([date, reorderResponses]) => {
        return (
          date === activeTab && (
            <div key={reorderResponses.displayDate}>
              <div
                style={{
                  height: "19.8rem",
                  overflowY: "scroll",
                }}
                 className="mt-1 px-3 scrollable-container grid-container"
              >
              {reorderResponses?.map((response) => (
                response?.responses?.map((element, index) => (
                  <div key={index} className="border rounded my-2 shadow">
                    <p className="m-0 p-2 border-bottom">{element.text}</p>
                    <p className="m-0 p-2 text-success">{element.response}</p>
                  </div>
                ))
              ))}
              </div>
            </div>
          )
        );
      })}
    </div>
  );
}

export default RecommendationSideSubTab;